import type {Component} from 'typings/portaro.fe.types';
import type {User} from 'typings/portaro.be.types';
import type {SearchManager} from '../../../search-manager';
import type UserService from '../../../../user/user.service';
import type ReloaderService from '../../../../commons/services/reloader.service';

export class KpSearchItemUserComponentController implements KpSearchItemUserComponentBindings {
    public user: User;
    public searchManager: SearchManager<any>;
    public canEdit: boolean;

    /*@ngInject*/
    constructor(private userService: UserService, private reloader: ReloaderService) {
    }

    public editUser(user) {
        this.userService.editUserByForm(user);
    }

    public async deleteUser(reader) {
        await this.userService.deleteUser(reader);

        if (this.searchManager) {
            this.searchManager.loadCurrentPage();
        } else {
            this.reloader.reload();
        }
    }
}

/**
 * @ngdoc component
 * @name kpSearchItemUser
 * @module portaro.search
 *
 * @param {User} user
 * @param {SearchManager<any, any>} [searchManager]
 * @param {boolean=} canEdit
 *
 * @description
 *
 */
export default class KpSearchItemUserComponent implements Component<KpSearchItemUserComponentBindings> {
    public static componentName = 'kpSearchItemUser';

    public templateUrl = require('./kp-search-item-user.tpl.ftl');

    public bindings = {
        user: '<',
        searchManager: '<?',
        canEdit: '<?'
    } as const;

    public controller = KpSearchItemUserComponentController;
}

interface KpSearchItemUserComponentBindings {
    user: User;
    searchManager?: SearchManager<any, any>;
    canEdit?: boolean;
}
